import { Config } from "../config/config.js";
import { Helper } from "./helper.js";
import { General } from "../../../siteManagement/general.js";
import { SheetEventType } from "../../../siteManagement/sheet.js";
import { MultiSelect } from "../components/multiSelect.js";
import { IsSearchFieldProps } from "../components/isSearchField.js";

interface FieldParams {
    searchWindowUrlParameterName
    searchWindowUrlParameterModel
    searchWindowUrl
    searchWindowUrlAdditionalParameterName
    searchWindowUrlAdditionalParameterModel
    fullObjectKey
    searchTextField
    searchValueField
    dataTextField
    dataValueField
}

export class SearchHelper {
    private hasValue = Helper.hasValue;
    private multiSelect: MultiSelect;

    private multiSelectValue = [];
    private _multiSelectDataSource = [];
    private _multiSelectRawDataSource = [];
    //private field;
    //private handleEval;
    //private onChange;
    //private handleIsSearchFieldFullObjectModel;
    //private multiSelectMode;
    //private onOpened;

    //constructor(field: any, handleEval: any, onChange: any, handleIsSearchFieldFullObjectModel: any, onOpened: any) {
    //    this.field = field;
    //    this.handleEval = handleEval;
    //    this.onChange = onChange;
    //    this.handleIsSearchFieldFullObjectModel = handleIsSearchFieldFullObjectModel;
    //    this.onOpened = onOpened;
    //}

    private _setMultiSelectData = (field: any, items: Array<any>, textField: string, valueField: string) => {
        let ds = [];
        //create a new data source
        for (var i = 0; i < items.length; i++) {
            let tmp = {};
            tmp[field.dataTextField] = items[i][textField];
            tmp[field.dataValueField] = items[i][valueField];
            ds.push(tmp);
        }
        this._multiSelectRawDataSource = items;
        this._multiSelectDataSource = ds;
        //copy the data source into the value (not in "props", because you "can't change props"...)
        this.multiSelectValue = ds.slice();
        if (this.hasValue(this.multiSelect)) {
            this.multiSelect.setDataSourceItems(ds);
            this.multiSelect.setValue();
        }
    }

    public openSearch(searchProps: IsSearchFieldProps, onChange: any, handleIsSearchFieldFullObjectModel: any, onOpened: any, onClosed: any = null) {

        let dynamicSearchUrl = Config.baseUrl + searchProps.field.searchWindowUrl;

        // Parameter einsetzen falls definiert (eval über root component durchführen lassen)
        if (this.hasValue(searchProps.field.searchWindowUrlParameterName) && this.hasValue(searchProps.field.searchWindowUrlParameterModel)) {
            let parameterQualifier = dynamicSearchUrl.indexOf("?") != -1 ? "&" : "?";
            let paramValue = searchProps.handleEval(searchProps.field.searchWindowUrlParameterModel);
            if (this.hasValue(paramValue)) {
                dynamicSearchUrl = dynamicSearchUrl + parameterQualifier + searchProps.field.searchWindowUrlParameterName + "=" + paramValue;
            }
        }

        if (this.hasValue(searchProps.field.searchWindowUrlAdditionalParameterName) && this.hasValue(searchProps.field.searchWindowUrlAdditionalParameterModel)) {
            let parameterQualifier = dynamicSearchUrl.indexOf("?") != -1 ? "&" : "?";
            let paramValue = searchProps.handleEval(searchProps.field.searchWindowUrlAdditionalParameterModel);
            if (this.hasValue(paramValue)) {
                dynamicSearchUrl = dynamicSearchUrl + parameterQualifier + searchProps.field.searchWindowUrlAdditionalParameterName + "=" + paramValue;
            }
        }

        const sheet = General.Sheet.Manager.createSheetWithUrl(dynamicSearchUrl, null, { disableTabTitle: true });
        sheet.bind(SheetEventType.RowClicked, (data) => {
            if (typeof data === "object") {
                if (Helper.hasValue(searchProps.field.fullObjectKey)) {
                    onChange(searchProps.field, data[searchProps.field.fullObjectKey], null)
                }
                handleIsSearchFieldFullObjectModel(searchProps.field, data);
            }
            else {
                onChange(searchProps.field, data, null);
            }
        });

        sheet.bind(SheetEventType.ItemsSelected, (data) => {
            if (searchProps.multiSelectMode) {
                onChange(searchProps.field, this.multiSelectValue, data.data);
                sheet.unbind(SheetEventType.ItemsSelected);
            }
        });

        sheet.bind(SheetEventType.Close, (data) => {
            onClosed && onClosed();

        });

        onOpened && onOpened();
    }
}